import { LinkPartial } from '../../../../partials/link';
import type {
  HeaderNavigationLevel2,
  HeaderNavigationLevel3Content,
  LinkedText,
} from '../../../../types/navigationHierarchyData';
import { sendNavigationEvent } from '../../../../utils/gtm/events/navigation/sendNavigationEvent';
import { NavLinkItemHeader, NavigationListItemContainer, ProductTypeList } from './NavigationListItem.styles';

type NavigationListItemProps = {
  navLink: HeaderNavigationLevel2 & LinkedText;
  handleCloseMenu: () => void;
};

export function NavigationListItem({ navLink, handleCloseMenu }: NavigationListItemProps) {
  const { text, link, linkedContentChildData } = navLink;
  const handleCLick = (linkText: string) => () => {
    sendNavigationEvent({
      component_header: text,
      component_type: 'main nav - text link',
      link_text: linkText,
    });
    setTimeout(() => {
      handleCloseMenu();
    }, 300);
  };

  return (
    <NavigationListItemContainer>
      <NavLinkItemHeader>
        <LinkPartial ariaLabel={text} {...link} onClick={handleCLick(text as string)}>
          {text}
        </LinkPartial>
      </NavLinkItemHeader>
      {linkedContentChildData && (
        <ProductTypeList>
          {linkedContentChildData.map((productType: HeaderNavigationLevel3Content, idx: number) => (
            <li key={`product-type-${idx}`}>
              <LinkPartial
                role="menuitem"
                ariaLabel={`${text}, ${productType?.content?.text}`}
                onClick={handleCLick(productType.content?.text as string)}
                {...productType?.content?.link}
              >
                {productType?.content?.text}
              </LinkPartial>
            </li>
          ))}
        </ProductTypeList>
      )}
    </NavigationListItemContainer>
  );
}
